import React, {  } from 'react';
import Home from './views/home'

const App = () => (
    <Home />
)

export default App;



// WEBPACK FOOTER //
// ./src/App.js